import { Spinner, cn } from "./ui";

interface LoadingProps {
  label?: string;
  /** Fill the viewport (route guards, app boot) instead of the parent */
  fullScreen?: boolean;
  className?: string;
}

/** Brand-consistent loading indicator for pages and route transitions */
const Loading = ({ label = "Loading...", fullScreen = false, className }: LoadingProps) => (
  <div
    className={cn(
      "flex w-full items-center justify-center",
      fullScreen ? "min-h-screen bg-canvas" : "min-h-[50vh] py-16",
      className
    )}
  >
    <Spinner label={label} className="size-6" />
  </div>
);

export default Loading;
